// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../types";

import gql from "graphql-tag";
import { DetailsCardProposalFragmentDoc } from "./DetailsCard/DetailsCard.generated-types";
import { ProposalButtonsProposalFragmentDoc } from "./ProposalButtons/ProposalButtons.generated-types";
import { ProposalInfoCardProposalFragmentDoc } from "./ProposalInfoCard/ProposalInfoCard.generated-types";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ProposalGetProposalQueryQueryVariables = Types.Exact<{
  UUIDs: Array<Types.Scalars["ID"]> | Types.Scalars["ID"];
}>;

export type ProposalGetProposalQueryQuery = {
  __typename?: "Query";
  getProposalsByUUIDs: Array<{
    __typename?: "Proposal";
    UUID: string;
    status: Types.ProposalStatus;
    ID: number;
    attendees: number;
    baseCostDescription: string;
    baseCostTotal: number;
    currency: string;
    message?: string | null;
    fromDateTime: string;
    toDateTime: string;
    event: { __typename?: "Event"; UUID: string };
    space: {
      __typename?: "SelfServeSpace";
      spaceName?: string | null;
      description?: string | null;
      tour3dUrl?: string | null;
      hostContact: {
        __typename?: "HostContact";
        email?: string | null;
        phoneNumber?: string | null;
        avatar?: {
          __typename?: "Avatar";
          normal?: string | null;
          small?: string | null;
          thumb?: string | null;
        } | null;
      };
      spaceFeatures?: Array<{
        __typename?: "SelfServeSpaceFeature";
        ID?: number | null;
        name?: string | null;
      }> | null;
      spaceDocuments?: Array<{
        __typename?: "SpaceDocument";
        url?: string | null;
        s3Key?: string | null;
        tag?: Types.SpaceDocumentTag | null;
        id?: number | null;
        filename?: string | null;
      } | null> | null;
      venue?: {
        __typename?: "SelfServeVenue";
        name?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        addressLine1?: string | null;
        city?: string | null;
        postalCode?: string | null;
        ID?: number | null;
        nearestTransit?: {
          __typename?: "NearestTransit";
          station?: string | null;
          distanceKm?: number | null;
        } | null;
      } | null;
      spatialConfigurations?: Array<{
        __typename?: "SelfServeSpatialConfiguration";
        name?: string | null;
        capacity?: number | null;
      }> | null;
      spacePhotos?: Array<{
        __typename?: "SelfServeSpacePhoto";
        url?: string | null;
      }> | null;
    };
    extraCostItems?: Array<{
      __typename?: "ExtraCostItem";
      ID: number;
      costPerUnit: number;
      description: string;
    }> | null;
    documents?: Array<{
      __typename?: "ProposalDocument";
      URL: string;
      s3Key: string;
      ID: number;
      filename: string;
    }> | null;
  }>;
};

export type ProposalUpdateProposalMutationMutationVariables = Types.Exact<{
  input: Types.UpdateProposalInput;
}>;

export type ProposalUpdateProposalMutationMutation = {
  __typename?: "Mutation";
  updateProposal: {
    __typename?: "Proposal";
    UUID: string;
    status: Types.ProposalStatus;
    ID: number;
    attendees: number;
    baseCostDescription: string;
    baseCostTotal: number;
    currency: string;
    message?: string | null;
    fromDateTime: string;
    toDateTime: string;
    event: { __typename?: "Event"; UUID: string };
    space: {
      __typename?: "SelfServeSpace";
      spaceName?: string | null;
      description?: string | null;
      tour3dUrl?: string | null;
      hostContact: {
        __typename?: "HostContact";
        email?: string | null;
        phoneNumber?: string | null;
        avatar?: {
          __typename?: "Avatar";
          normal?: string | null;
          small?: string | null;
          thumb?: string | null;
        } | null;
      };
      spaceFeatures?: Array<{
        __typename?: "SelfServeSpaceFeature";
        ID?: number | null;
        name?: string | null;
      }> | null;
      spaceDocuments?: Array<{
        __typename?: "SpaceDocument";
        url?: string | null;
        s3Key?: string | null;
        tag?: Types.SpaceDocumentTag | null;
        id?: number | null;
        filename?: string | null;
      } | null> | null;
      venue?: {
        __typename?: "SelfServeVenue";
        name?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        addressLine1?: string | null;
        city?: string | null;
        postalCode?: string | null;
        ID?: number | null;
        nearestTransit?: {
          __typename?: "NearestTransit";
          station?: string | null;
          distanceKm?: number | null;
        } | null;
      } | null;
      spatialConfigurations?: Array<{
        __typename?: "SelfServeSpatialConfiguration";
        name?: string | null;
        capacity?: number | null;
      }> | null;
      spacePhotos?: Array<{
        __typename?: "SelfServeSpacePhoto";
        url?: string | null;
      }> | null;
    };
    extraCostItems?: Array<{
      __typename?: "ExtraCostItem";
      ID: number;
      costPerUnit: number;
      description: string;
    }> | null;
    documents?: Array<{
      __typename?: "ProposalDocument";
      URL: string;
      s3Key: string;
      ID: number;
      filename: string;
    }> | null;
  };
};

export type ProposalUpdateBaseDetailsMutationMutationVariables = Types.Exact<{
  input: Types.UpdateProposalBaseDetailsInput;
}>;

export type ProposalUpdateBaseDetailsMutationMutation = {
  __typename?: "Mutation";
  updateProposalBaseDetails: {
    __typename?: "Proposal";
    UUID: string;
    status: Types.ProposalStatus;
    ID: number;
    attendees: number;
    baseCostDescription: string;
    baseCostTotal: number;
    currency: string;
    message?: string | null;
    fromDateTime: string;
    toDateTime: string;
    event: { __typename?: "Event"; UUID: string };
    space: {
      __typename?: "SelfServeSpace";
      spaceName?: string | null;
      description?: string | null;
      tour3dUrl?: string | null;
      hostContact: {
        __typename?: "HostContact";
        email?: string | null;
        phoneNumber?: string | null;
        avatar?: {
          __typename?: "Avatar";
          normal?: string | null;
          small?: string | null;
          thumb?: string | null;
        } | null;
      };
      spaceFeatures?: Array<{
        __typename?: "SelfServeSpaceFeature";
        ID?: number | null;
        name?: string | null;
      }> | null;
      spaceDocuments?: Array<{
        __typename?: "SpaceDocument";
        url?: string | null;
        s3Key?: string | null;
        tag?: Types.SpaceDocumentTag | null;
        id?: number | null;
        filename?: string | null;
      } | null> | null;
      venue?: {
        __typename?: "SelfServeVenue";
        name?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        addressLine1?: string | null;
        city?: string | null;
        postalCode?: string | null;
        ID?: number | null;
        nearestTransit?: {
          __typename?: "NearestTransit";
          station?: string | null;
          distanceKm?: number | null;
        } | null;
      } | null;
      spatialConfigurations?: Array<{
        __typename?: "SelfServeSpatialConfiguration";
        name?: string | null;
        capacity?: number | null;
      }> | null;
      spacePhotos?: Array<{
        __typename?: "SelfServeSpacePhoto";
        url?: string | null;
      }> | null;
    };
    extraCostItems?: Array<{
      __typename?: "ExtraCostItem";
      ID: number;
      costPerUnit: number;
      description: string;
    }> | null;
    documents?: Array<{
      __typename?: "ProposalDocument";
      URL: string;
      s3Key: string;
      ID: number;
      filename: string;
    }> | null;
  };
};

export type ProposalProposalFragment = {
  __typename?: "Proposal";
  UUID: string;
  status: Types.ProposalStatus;
  ID: number;
  attendees: number;
  baseCostDescription: string;
  baseCostTotal: number;
  currency: string;
  message?: string | null;
  fromDateTime: string;
  toDateTime: string;
  event: { __typename?: "Event"; UUID: string };
  space: {
    __typename?: "SelfServeSpace";
    spaceName?: string | null;
    description?: string | null;
    tour3dUrl?: string | null;
    hostContact: {
      __typename?: "HostContact";
      email?: string | null;
      phoneNumber?: string | null;
      avatar?: {
        __typename?: "Avatar";
        normal?: string | null;
        small?: string | null;
        thumb?: string | null;
      } | null;
    };
    spaceFeatures?: Array<{
      __typename?: "SelfServeSpaceFeature";
      ID?: number | null;
      name?: string | null;
    }> | null;
    spaceDocuments?: Array<{
      __typename?: "SpaceDocument";
      url?: string | null;
      s3Key?: string | null;
      tag?: Types.SpaceDocumentTag | null;
      id?: number | null;
      filename?: string | null;
    } | null> | null;
    venue?: {
      __typename?: "SelfServeVenue";
      name?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      addressLine1?: string | null;
      city?: string | null;
      postalCode?: string | null;
      ID?: number | null;
      nearestTransit?: {
        __typename?: "NearestTransit";
        station?: string | null;
        distanceKm?: number | null;
      } | null;
    } | null;
    spatialConfigurations?: Array<{
      __typename?: "SelfServeSpatialConfiguration";
      name?: string | null;
      capacity?: number | null;
    }> | null;
    spacePhotos?: Array<{
      __typename?: "SelfServeSpacePhoto";
      url?: string | null;
    }> | null;
  };
  extraCostItems?: Array<{
    __typename?: "ExtraCostItem";
    ID: number;
    costPerUnit: number;
    description: string;
  }> | null;
  documents?: Array<{
    __typename?: "ProposalDocument";
    URL: string;
    s3Key: string;
    ID: number;
    filename: string;
  }> | null;
};

export type ProposalSpaceFragment = {
  __typename?: "SelfServeSpace";
  spacePhotos?: Array<{
    __typename?: "SelfServeSpacePhoto";
    url?: string | null;
  }> | null;
  spaceDocuments?: Array<{
    __typename?: "SpaceDocument";
    url?: string | null;
    s3Key?: string | null;
    tag?: Types.SpaceDocumentTag | null;
    id?: number | null;
    filename?: string | null;
  } | null> | null;
  venue?: { __typename?: "SelfServeVenue"; name?: string | null } | null;
};

export const ProposalSpaceFragmentDoc = gql`
  fragment ProposalSpace on SelfServeSpace {
    spacePhotos {
      url
    }
    spaceDocuments {
      url
      s3Key
      tag
      id
      filename
    }
    venue {
      name
    }
  }
`;
export const ProposalProposalFragmentDoc = gql`
  fragment ProposalProposal on Proposal {
    UUID
    status
    event {
      UUID
    }
    space {
      ...ProposalSpace
    }
    ...DetailsCardProposal
    ...ProposalButtonsProposal
    ...ProposalInfoCardProposal
  }
  ${ProposalSpaceFragmentDoc}
  ${DetailsCardProposalFragmentDoc}
  ${ProposalButtonsProposalFragmentDoc}
  ${ProposalInfoCardProposalFragmentDoc}
`;
export const ProposalGetProposalQueryDocument = gql`
  query ProposalGetProposalQuery($UUIDs: [ID!]!) {
    getProposalsByUUIDs(UUIDs: $UUIDs) {
      ...ProposalProposal
    }
  }
  ${ProposalProposalFragmentDoc}
`;

export function useProposalGetProposalQueryQuery(
  options: Omit<
    Urql.UseQueryArgs<ProposalGetProposalQueryQueryVariables>,
    "query"
  >
) {
  return Urql.useQuery<
    ProposalGetProposalQueryQuery,
    ProposalGetProposalQueryQueryVariables
  >({ query: ProposalGetProposalQueryDocument, ...options });
}
export const ProposalUpdateProposalMutationDocument = gql`
  mutation ProposalUpdateProposalMutation($input: UpdateProposalInput!) {
    updateProposal(input: $input) {
      ...ProposalProposal
    }
  }
  ${ProposalProposalFragmentDoc}
`;

export function useProposalUpdateProposalMutationMutation() {
  return Urql.useMutation<
    ProposalUpdateProposalMutationMutation,
    ProposalUpdateProposalMutationMutationVariables
  >(ProposalUpdateProposalMutationDocument);
}
export const ProposalUpdateBaseDetailsMutationDocument = gql`
  mutation ProposalUpdateBaseDetailsMutation(
    $input: UpdateProposalBaseDetailsInput!
  ) {
    updateProposalBaseDetails(input: $input) {
      ...ProposalProposal
    }
  }
  ${ProposalProposalFragmentDoc}
`;

export function useProposalUpdateBaseDetailsMutationMutation() {
  return Urql.useMutation<
    ProposalUpdateBaseDetailsMutationMutation,
    ProposalUpdateBaseDetailsMutationMutationVariables
  >(ProposalUpdateBaseDetailsMutationDocument);
}
